import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  AllianceOverview,
  ArchitectureSummary,
  Metrics,
  AreYouReady,
} from './components';

const LandingMediaKitCinepic = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Hero themeMode={themeMode} />
      </Container>
      <Container>
        <AllianceOverview />
      </Container>
      <Container>
        <ArchitectureSummary />
      </Container>
      <Container>
        <Metrics />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitCinepic.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitCinepic;

